export const config  = {
  api:  {
      port: process.env.SERVICE_BIND_PORT || 8000,
      base: process.env.API_BASE_URL || "http://test01.elmenus.com/2.0",
      apiBase: process.env.BASE_URL || "http://test01.elmenus.com/api",
      restBase: process.env.API_REST_BASE_URL || "http://test01.elmenus.com/api/steering/restaurant/v1",
      orderBase: process.env.API_ORDER_BASE_URL || "http://test01.elmenus.com/api/order-svc/2.0",
      tripBase:process.env.API_TRIP_BASE_URL || "http://test01.elmenus.com/api/trip-svc/1.0/trip",
      auth: process.env.AUTH_BASE_URL || "http://test01.elmenus.com/api/auth-svc/1.0"
  },
  logger: {
    level: process.env.LOG_LEVEL || "debug"
  },
  headers: {
    xTracking: 'X-Tracking',
    clientModel: 'WEB',
    clientVersion: '5'

  },
  cookie: {
    language: "lang",
    jwt: "Authorization",
    area: 'userArea',
    city: 'userCity',
    zone: 'userZone',
    company:'Company',
    lat:'lat',
    long:'long',
    FOPModal: 'FOPModal',
    deviceID: 'payload',
    refreshToken: 'webRefreshToken',
    webAccessTokenExpiry: 'webAccessTokenExpiry'
  },
  webClientID: '0417b144-0f3f-11e8-87cc-0242ac110002',
  allowGuest: process.env.ALLOW_GUEST && (process.env.ALLOW_GUEST.toString() == 'true') ? true : false,
  crawler: /googlebot/i,
  appMode: process.env.NODE_ENV || "development",
  lt_link: process.env.LT_LINK, //old LT link
  lt_link_new: process.env.LT_LINK_NEW, //new LT link
  download_link: process.env.DOWNLOAD_LINK,
}
